/* Copyright 2013 - 2024 Waiterio LLC */
import delete_ from './delete_.js'

export default function deleteInvite(inviteId) {
  return delete_({ url: 'invites/' + inviteId }).catch(error => {
    throw new Error(`Couldn't delete invite\n${error}`)
  })
}
